<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <div v-if="options && options.length > 0">
      <div class="com">
        <div class="com_box">
          <div class="com_left">
            <div v-if="comInfo.type == '2'" class="ybStyle">般</div>
            <div v-if="comInfo.type == '1'" class="xgmStyle">小</div>
            <el-select
              v-model="comId"
              placeholder="请选择"
              style="width: 80%"
              @change="changeCom"
              size="small"
            >
              <el-option
                v-for="item in options"
                :key="item.comId"
                :label="item.name"
                :value="item.comId"
              >
                <div>
                  <span
                    v-if="item.type == '1'"
                    class="xgmStyle"
                    style="font-size: 11px"
                    >小</span
                  >
                  <span
                    v-if="item.type == '2'"
                    class="ybStyle"
                    style="font-size: 11px"
                    >般</span
                  >{{ item.name }}
                </div>
              </el-option>
            </el-select>
            <el-icon size="20px" @click="copy" class="copy_style">
              <document-copy />
            </el-icon>
          </div>
          <div></div>
        </div>
      </div>
      <div class="tab-container">
        <div class="tabs">
          <div
            v-for="(tab, index) in tabOption"
            :key="index"
            :class="['tab', { active: activeTab === index }]"
            @click="selectTab(index)"
          >
            {{ tab }}
          </div>
        </div>
        <div class="top_select" v-if="![5, 6].includes(activeTab)">
          <div>
            <el-select
              v-model="selectPeriod"
              placeholder="请选择"
              size="small"
              @change="changePeriod"
              style="width: 150px"
            >
              <el-option
                v-for="item in periodOption"
                :key="item.period"
                :label="item.period"
                :value="item.period"
              >
              </el-option>
            </el-select>
            <el-button
              type="primary"
              icon="Refresh"
              @click="refreshComponent"
              size="small"
              >刷新</el-button
            >
          </div>
        </div>
        <div>
          <component
            v-if="currentTabComponent"
            :is="currentTabComponent"
            :period="selectPeriod"
            :comInfo="comInfo"
            :cKey="componentKey"
          >
          </component>
        </div>
      </div>
    </div>
    <div v-else style="margin-top: 50px">
      <el-empty description="暂未绑定公司，请在系统绑定 " :image-size="80" />
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, getCurrentInstance, computed } from "vue"
import axios from "axios"
import { currentAccountPeriod } from "@/utils"
import { getUrlParams } from "@/utils/fun"
import { ElMessage } from "element-plus"
import HomePageIndex from "@/views/HomePage/HomePageIndex.vue"
import CustomerIndex from "@/views/Customer/CustomerIndex.vue"
import CloudDiskIndex from "@/views/CloudDisk/CloudDiskIndex.vue"
// import InvoiceIndex from "@/views/Invoice/InvoiceIndex.vue"
import FinanceIndex from "@/views/Finance/FinanceIndex.vue"
import ThinkTankIndex from "@/views/ThinkTank/ThinkTankIndex.vue"
import BillIndex from "@/views/Bill/BillIndex.vue"
import TaxIndex from "@/views/Tax/TaxIndex.vue"
import { qywxComList, qywxComInfo, login } from "@/api/home"
const { proxy } = getCurrentInstance()
const tabOption = ref(["首页", "客户", "单据", "税款", "报表", "云盘", "智库"])
const activeTab = ref(0)
const comId = ref(null)
const options = ref([])
const comInfo = ref({})
const fullscreenLoading = ref(false)
const chatId = ref("") //wrYTEESQAA90EIm7yaXFhBJiTK3rzzIA wrYTEESQAAbIDfSfhP5klyRqv2Ld76qA
const periodOption = ref([])
const selectPeriod = ref()
const currentPeriod = currentAccountPeriod()
const componentKey = ref(0)
const isFetching = ref(false)
const getChatId = async () => {
  let url = window.location.href
  let auth_code = getUrlParams(url, "auth_code")
  fullscreenLoading.value = true
  if (auth_code != "") {
    await axios.post(
      "https://public.listensoft.net/api/getPermanentCodeByAuthCode",
      {
        auth_code: auth_code,
      }
    )
  } else {
    await axios
      .post("https://public.listensoft.net/api/getVisitorInfo", {
        url: url,
      })
      .then((res) => {
        if (res.data.msg == "success") {
          let agentConfigParams = res.data.data.agentConfigParams
          let configParams = res.data.data.configParams
          proxy.$store.dispatch("user/setParam", res.data.data.userId)
          wx.config({
            beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: configParams.appId, // 必填，企业微信的corpID，必须是本企业的corpID，不允许跨企业使用
            timestamp: configParams.timestamp, // 必填，生成签名的时间戳
            nonceStr: configParams.nonceStr, // 必填，生成签名的随机串
            signature: configParams.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
            jsApiList: [
              "openExistedChatWithMsg",
              "getCurExternalChat",
              "sendChatMessage",
            ], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
          })
          wx.agentConfig({
            corpid: agentConfigParams.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
            agentid: agentConfigParams.agentid, // 必填，企业微信的应用id （e.g. 1000247）
            timestamp: agentConfigParams.timestamp, // 必填，生成签名的时间戳
            nonceStr: agentConfigParams.nonceStr, // 必填，生成签名的随机串
            signature: agentConfigParams.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
            jsApiList: [
              "openExistedChatWithMsg",
              "getCurExternalChat",
              "sendChatMessage",
              // "selectExternalContact"
            ], //必填，传入需要使用的接口名称
            success: function () {
              // 回调
              // console.log(res);
              ff()
            },
            fail: function (res) {
              if (res.errMsg.indexOf("function not exist") > -1) {
                alert("版本过低请升级")
              }
            },
          })
        }
      })
      .catch(() => {
        fullscreenLoading.value = false
      })
  }
  fullscreenLoading.value = false
}

const ff = () => {
  wx.invoke("getCurExternalChat", {}, function (res) {
    if (res.err_msg == "getCurExternalChat:ok") {
      let chatIdVal = res.chatId //返回当前外部群的群聊ID
      // localStorage.setItem("chatId", chatId);
      chatId.value = chatIdVal
      getList()
    } else {
      alert("error", res.err_msg)
    }
  })
}
onMounted(() => {
  getChatId()
  // getList()
})
const getList = async () => {
  if (isFetching.value) return // 如果已经在请求中则直接返回
  isFetching.value = true
  if (!chatId.value) {
    ElMessage.error("所属群未绑定机构，无法登录")
    isFetching.value = false
    return
  }
  try {
    const loginRes = await login({ chatId: chatId.value })
    if (loginRes.data.msg === "success") {
      localStorage.setItem("token", loginRes.data.token)
    } else {
      ElMessage.error("暂未绑定公司，请在系统内绑定")
      localStorage.removeItem("token")
      isFetching.value = false
      return
    }
    const comListRes = await qywxComList({})
    if (comListRes.data.msg === "success") {
      options.value = comListRes.data.data
      if (comListRes.data.data && comListRes.data.data.length > 0) {
        comId.value = comListRes.data.data[0].comId
      }
      changeCom()
    }
  } catch (error) {
    console.error(error)
  } finally {
    isFetching.value = false
  }
}

const changeCom = () => {
  proxy.$store.dispatch("user/InitPeriod", comId.value).then(() => {
    qywxComInfo({
      comId: comId.value,
    }).then((res) => {
      if (res.data.msg == "success") {
        comInfo.value = res.data.data
        periodOption.value = proxy.$store.getters["user/periods"]
        let arr = periodOption.value?.map((item) => {
          return item.period
        })
        selectPeriod.value = arr.includes(currentPeriod)
          ? currentPeriod
          : periodOption.value[0].period
      }
    })
  })
}
const changePeriod = (val) => {
  selectPeriod.value = val
}
const currentTabComponent = computed(() => {
  switch (activeTab.value) {
    case 0:
      return HomePageIndex
    case 1:
      return CustomerIndex
    case 2:
      return BillIndex
    case 3:
      return TaxIndex
    case 4:
      return FinanceIndex
    case 5:
      return CloudDiskIndex
    case 6:
      return ThinkTankIndex
    default:
      return HomePageIndex
  }
})

const selectTab = (index) => {
  activeTab.value = index
}
const refreshComponent = () => {
  componentKey.value += 1
}
const copy = () => {
  let a = ""
  options.value.map((item) => {
    if (comId.value == item.comId) {
      a = item.name
    }
  })
  //创建input标签
  var input = document.createElement("input")
  //将input的值设置为需要复制的内容
  input.value = a
  //添加input标签
  document.body.appendChild(input)
  //选中input标签
  input.select()
  //执行复制
  document.execCommand("copy")
  //成功提示信息
  ElMessage.success("复制成功！")
  //移除input标签
  document.body.removeChild(input)
}
</script>
<style scoped lang="scss">
.com {
  padding: 20px 10px;
  border-bottom: 1px solid #efefef;
  background-color: #fff;
  font-size: 14px;
}

.com_box {
  width: 98%;
  margin: 0 auto;
}

.com_left {
  display: flex;
  align-items: center;
}

.copy_style {
  color: $color-main;
  cursor: pointer;
  margin-left: 5px;
}

.tab-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 14px;
}

.tabs {
  display: flex;
  border-bottom: 1px solid #e4e7ed;
  background-color: #fff;
}

.tab {
  width: 14.2%;
  text-align: center;
  padding: 8px 0px;
  cursor: pointer;
  position: relative;
}

.tab.active {
  color: $color-main;
  border-bottom: 1px solid $color-main;
}

.top_select {
  margin: 10px 0;
}
</style>
